import { FormProvider } from "react-hook-form";

import { cpfMask } from "@/app/utils/cpfFormater";
import { phoneMask } from "@/app/utils/phoneFormater";
import { zipCodeMask } from "@/app/utils/zipCodeFormater";
import { BasicInput } from "@/view/components/BasicInput";
import { Button } from "@/view/components/ui/button";
import {
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/view/components/ui/dialog";
import usePreAnalysisModal from "./usePreAnalysisModal";

interface PreAnalysisModalProps {
  onContinue: () => void;
  onBack: () => void;
}

export default function PreAnalysisModal({
  onContinue,
  onBack,
}: PreAnalysisModalProps) {
  const { form, submitModal, loading, isFetchingCustomer } = usePreAnalysisModal(
    { onContinue },
  );

  const {
    formState: { errors },
  } = form;

  return (
    <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-3xl">
      <DialogHeader>
        <DialogTitle className="text-xl font-semibold text-black01">
          Vamos consultar o crédito
        </DialogTitle>
        <DialogDescription className="!mt-0 text-base text-black04">
          Preencha os dados abaixo para iniciar a pré-análise na Crefaz
        </DialogDescription>
      </DialogHeader>

      <form onSubmit={submitModal}>
        <FormProvider {...form}>
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            <BasicInput
              name="cpf"
              label="CPF"
              error={errors.cpf?.message}
              onInput={cpfMask}
              maxLength={14}
            />
            <BasicInput
              name="name"
              label="Nome completo"
              error={errors.name?.message}
            />

            {isFetchingCustomer && (
              <p className="-mt-3 text-sm text-black04 sm:col-span-2">
                Buscando dados do cliente...
              </p>
            )}

            <BasicInput
              name="birthDate"
              type="date"
              label="Data de nascimento"
              error={errors.birthDate?.message}
            />
            <BasicInput
              name="phone"
              label="Telefone"
              error={errors.phone?.message}
              onInput={phoneMask}
            />
            <BasicInput
              name="email"
              label="E-mail"
              error={errors.email?.message}
            />
          </div>

          <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2">
            <BasicInput
              name="cep"
              label="CEP"
              placeholder="00000-000"
              error={errors.cep?.message}
              onInput={zipCodeMask}
              maxLength={9}
            />
            <BasicInput
              name="logradouro"
              label="Logradouro"
              error={errors.logradouro?.message}
            />
            <BasicInput
              name="bairro"
              label="Bairro"
              error={errors.bairro?.message}
            />
            <div className="grid grid-cols-[1fr_100px] gap-4">
              <BasicInput
                name="cidade"
                label="Cidade"
                error={errors.cidade?.message}
              />
              <BasicInput
                name="uf"
                label="UF"
                maxLength={2}
                error={errors.uf?.message}
              />
            </div>
          </div>

          <div className="mt-8 flex justify-end gap-2">
            <Button
              type="button"
              variant="outline"
              onClick={onBack}
              className="w-[160px] rounded-full text-primary"
            >
              Voltar
            </Button>
            <Button
              type="submit"
              className="w-[160px] rounded-full font-semibold text-white"
              isLoading={loading}
              disabled={loading}
            >
              Continuar
            </Button>
          </div>
        </FormProvider>
      </form>
    </DialogContent>
  );
}
